/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfListOfOrganizationCustomFieldsDropDownDto } from '../models/custom-result-of-list-of-organization-custom-fields-drop-down-dto';
import { CustomResultOfOrganizationCustomFieldByIdDto } from '../models/custom-result-of-organization-custom-field-by-id-dto';
import { CustomResultOfPaginatedListOfOrganizationCustomFieldsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-organization-custom-fields-with-pagination-dto';
import { organizationCustomFieldsCreateGet } from '../fn/organization-custom-fields/organization-custom-fields-create-get';
import { OrganizationCustomFieldsCreateGet$Params } from '../fn/organization-custom-fields/organization-custom-fields-create-get';
import { organizationCustomFieldsCreatePost } from '../fn/organization-custom-fields/organization-custom-fields-create-post';
import { OrganizationCustomFieldsCreatePost$Params } from '../fn/organization-custom-fields/organization-custom-fields-create-post';
import { organizationCustomFieldsDelete } from '../fn/organization-custom-fields/organization-custom-fields-delete';
import { OrganizationCustomFieldsDelete$Params } from '../fn/organization-custom-fields/organization-custom-fields-delete';
import { organizationCustomFieldsGetOrganizationCustomFieldAudits } from '../fn/organization-custom-fields/organization-custom-fields-get-organization-custom-field-audits';
import { OrganizationCustomFieldsGetOrganizationCustomFieldAudits$Params } from '../fn/organization-custom-fields/organization-custom-fields-get-organization-custom-field-audits';
import { organizationCustomFieldsGetOrganizationCustomFieldsDropDown } from '../fn/organization-custom-fields/organization-custom-fields-get-organization-custom-fields-drop-down';
import { OrganizationCustomFieldsGetOrganizationCustomFieldsDropDown$Params } from '../fn/organization-custom-fields/organization-custom-fields-get-organization-custom-fields-drop-down';
import { organizationCustomFieldsGetOrganizationCustomFieldsWithPagination } from '../fn/organization-custom-fields/organization-custom-fields-get-organization-custom-fields-with-pagination';
import { OrganizationCustomFieldsGetOrganizationCustomFieldsWithPagination$Params } from '../fn/organization-custom-fields/organization-custom-fields-get-organization-custom-fields-with-pagination';
import { organizationCustomFieldsUpdateGet } from '../fn/organization-custom-fields/organization-custom-fields-update-get';
import { OrganizationCustomFieldsUpdateGet$Params } from '../fn/organization-custom-fields/organization-custom-fields-update-get';
import { organizationCustomFieldsUpdatePut } from '../fn/organization-custom-fields/organization-custom-fields-update-put';
import { OrganizationCustomFieldsUpdatePut$Params } from '../fn/organization-custom-fields/organization-custom-fields-update-put';

@Injectable({ providedIn: 'root' })
export class OrganizationCustomFieldsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `organizationCustomFieldsGetOrganizationCustomFieldAudits()` */
  static readonly OrganizationCustomFieldsGetOrganizationCustomFieldAuditsPath = '/OrganizationCustomFields/GetOrganizationCustomFieldAudits';

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationCustomFieldsGetOrganizationCustomFieldAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationCustomFieldsGetOrganizationCustomFieldAudits$Response(params: OrganizationCustomFieldsGetOrganizationCustomFieldAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return organizationCustomFieldsGetOrganizationCustomFieldAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam users, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationCustomFieldsGetOrganizationCustomFieldAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationCustomFieldsGetOrganizationCustomFieldAudits(params: OrganizationCustomFieldsGetOrganizationCustomFieldAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.organizationCustomFieldsGetOrganizationCustomFieldAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `organizationCustomFieldsCreateGet()` */
  static readonly OrganizationCustomFieldsCreateGetPath = '/OrganizationCustomFields/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationCustomFieldsCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationCustomFieldsCreateGet$Response(params?: OrganizationCustomFieldsCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return organizationCustomFieldsCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationCustomFieldsCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationCustomFieldsCreateGet(params?: OrganizationCustomFieldsCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.organizationCustomFieldsCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `organizationCustomFieldsCreatePost()` */
  static readonly OrganizationCustomFieldsCreatePostPath = '/OrganizationCustomFields/Create';

  /**
   * Create OrganizationCustomField.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationCustomFieldsCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationCustomFieldsCreatePost$Response(params: OrganizationCustomFieldsCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationCustomFieldsCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create OrganizationCustomField.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationCustomFieldsCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationCustomFieldsCreatePost(params: OrganizationCustomFieldsCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationCustomFieldsCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationCustomFieldsGetOrganizationCustomFieldsWithPagination()` */
  static readonly OrganizationCustomFieldsGetOrganizationCustomFieldsWithPaginationPath = '/OrganizationCustomFields/GetOrganizationCustomFieldsWithPagination';

  /**
   * For each user get OrganizationCustomFields with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationCustomFieldsGetOrganizationCustomFieldsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationCustomFieldsGetOrganizationCustomFieldsWithPagination$Response(params: OrganizationCustomFieldsGetOrganizationCustomFieldsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfOrganizationCustomFieldsWithPaginationDto>> {
    return organizationCustomFieldsGetOrganizationCustomFieldsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get OrganizationCustomFields with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationCustomFieldsGetOrganizationCustomFieldsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationCustomFieldsGetOrganizationCustomFieldsWithPagination(params: OrganizationCustomFieldsGetOrganizationCustomFieldsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfOrganizationCustomFieldsWithPaginationDto> {
    return this.organizationCustomFieldsGetOrganizationCustomFieldsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfOrganizationCustomFieldsWithPaginationDto>): CustomResultOfPaginatedListOfOrganizationCustomFieldsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `organizationCustomFieldsDelete()` */
  static readonly OrganizationCustomFieldsDeletePath = '/OrganizationCustomFields';

  /**
   * Delete Organization CustomField.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationCustomFieldsDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationCustomFieldsDelete$Response(params: OrganizationCustomFieldsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationCustomFieldsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Organization CustomField.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationCustomFieldsDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationCustomFieldsDelete(params: OrganizationCustomFieldsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationCustomFieldsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationCustomFieldsUpdatePut()` */
  static readonly OrganizationCustomFieldsUpdatePutPath = '/OrganizationCustomFields/Update';

  /**
   * Update OrganizationCustomField.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationCustomFieldsUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationCustomFieldsUpdatePut$Response(params: OrganizationCustomFieldsUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return organizationCustomFieldsUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update OrganizationCustomField.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationCustomFieldsUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationCustomFieldsUpdatePut(params: OrganizationCustomFieldsUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.organizationCustomFieldsUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `organizationCustomFieldsUpdateGet()` */
  static readonly OrganizationCustomFieldsUpdateGetPath = '/OrganizationCustomFields/Update/{id}';

  /**
   * Get OrganizationCustomField by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationCustomFieldsUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationCustomFieldsUpdateGet$Response(params: OrganizationCustomFieldsUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfOrganizationCustomFieldByIdDto>> {
    return organizationCustomFieldsUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get OrganizationCustomField by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationCustomFieldsUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationCustomFieldsUpdateGet(params: OrganizationCustomFieldsUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfOrganizationCustomFieldByIdDto> {
    return this.organizationCustomFieldsUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfOrganizationCustomFieldByIdDto>): CustomResultOfOrganizationCustomFieldByIdDto => r.body)
    );
  }

  /** Path part for operation `organizationCustomFieldsGetOrganizationCustomFieldsDropDown()` */
  static readonly OrganizationCustomFieldsGetOrganizationCustomFieldsDropDownPath = '/OrganizationCustomFields/GetOrganizationCustomFieldsDropDown';

  /**
   * Get Organization Custom Fields DropDown.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationCustomFieldsGetOrganizationCustomFieldsDropDown()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationCustomFieldsGetOrganizationCustomFieldsDropDown$Response(params?: OrganizationCustomFieldsGetOrganizationCustomFieldsDropDown$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfOrganizationCustomFieldsDropDownDto>> {
    return organizationCustomFieldsGetOrganizationCustomFieldsDropDown(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Organization Custom Fields DropDown.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `organizationCustomFieldsGetOrganizationCustomFieldsDropDown$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationCustomFieldsGetOrganizationCustomFieldsDropDown(params?: OrganizationCustomFieldsGetOrganizationCustomFieldsDropDown$Params, context?: HttpContext): Observable<CustomResultOfListOfOrganizationCustomFieldsDropDownDto> {
    return this.organizationCustomFieldsGetOrganizationCustomFieldsDropDown$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfOrganizationCustomFieldsDropDownDto>): CustomResultOfListOfOrganizationCustomFieldsDropDownDto => r.body)
    );
  }

}
